module.exports = __webpack_public_path__ + "static/media/default-image.6e182599.png";